"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValidationAuditFilter = void 0;
/*
 * Copyright 2022, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
const cloneDeep_1 = __importDefault(require("lodash/cloneDeep"));
//import _truncate from 'lodash/truncate';
const react_select_1 = __importDefault(require("react-select"));
const types_1 = require("evolution-common/lib/services/baseObjects/types");
const auditLevels = ['error', 'warning', 'info'];
/**
 * Textbox input for column filter
 *
 * @param param0 description of the filtered column
 * @returns
 */
const ValidationAuditFilter = ({ t, column: { filterValue, setFilter }, state: { filters } }) => {
    const [auditStats, setAuditStats] = react_1.default.useState({});
    const fetchIdRef = react_1.default.useRef(0);
    react_1.default.useEffect(() => {
        // Give this fetch an ID
        const fetchId = ++fetchIdRef.current;
        const loadAuditStats = () => __awaiter(void 0, void 0, void 0, function* () {
            // Make a query string from the filters
            const dataFilters = {};
            (filters || []).forEach((filter) => {
                if (typeof filter.value === 'string') {
                    dataFilters[filter.id] = filter.value;
                }
                else if (typeof filter.value === 'object' && filter.value.value !== undefined) {
                    const { value, op } = filter.value;
                    dataFilters[filter.id] = { value, op };
                }
                else if (Array.isArray(filter.value)) {
                    dataFilters[filter.id] = filter.value;
                }
            });
            try {
                const response = yield fetch('/api/validation/auditStats', {
                    headers: {
                        Accept: 'application/json',
                        'Content-Type': 'application/json'
                    },
                    credentials: 'include',
                    method: 'POST',
                    body: JSON.stringify(Object.assign({}, dataFilters))
                });
                if (fetchId !== fetchIdRef.current) {
                    // There was another query since, ignore
                    return;
                }
                if (response.status === 200) {
                    const jsonData = yield response.json();
                    const auditStats = jsonData.auditStats;
                    //data.unshift(undefined);
                    setAuditStats(auditStats);
                }
                else {
                    console.error('Invalid response code from server: ', response.status);
                }
            }
            catch (error) {
                console.error(`Error fetching user data from server: ${error}`);
                setAuditStats({});
            }
        });
        loadAuditStats();
        // To cleanup, just update the current ref so the widget won't update upon return
        return () => {
            fetchIdRef.current++;
        };
    }, [filters]);
    const auditFilterSelects = [];
    const selectedAuditKeyByLevel = {};
    const selectedAuditChoicesByLevel = {};
    for (const level of auditLevels) {
        const auditsBySurveyObject = auditStats[level] || {};
        selectedAuditChoicesByLevel[level] = [];
        selectedAuditKeyByLevel[level] = [];
        const groupedChoices = [];
        for (const surveyObject of types_1.surveyObjectNames) {
            const choices = [];
            const audits = auditsBySurveyObject[surveyObject] || [];
            for (let j = 0, countJ = audits.length; j < countJ; j++) {
                const audit = audits[j];
                const choice = {
                    value: audit.errorCode,
                    label: `• ${t([`audits:${audit.errorCode}`])} [${audit.count}]`
                };
                if (filterValue && filterValue.includes(audit.errorCode)) {
                    selectedAuditChoicesByLevel[level].push(choice);
                    selectedAuditKeyByLevel[level].push(audit.errorCode);
                }
                choices.push(choice);
            }
            groupedChoices.push({
                label: t(`admin:auditObjectTypes:${surveyObject}`),
                options: choices
            });
        }
        auditFilterSelects.push(react_1.default.createElement("div", { key: level },
            react_1.default.createElement("label", { htmlFor: `surveyValidation-filter-audit-level-${level}` }, t(`admin:auditLevels:${level}`)),
            react_1.default.createElement(react_select_1.default, { styles: {
                    // FIXME Remove the need for 'as any' by typing the styles properly. But there is compilation error even though it should be correct.
                    option: (baseStyles, _state) => (Object.assign(Object.assign({}, baseStyles), { paddingTop: 0, paddingBottom: 0 }))
                }, defaultValue: undefined, isMulti: true, value: selectedAuditChoicesByLevel[level], onChange: (newValue) => {
                    const existingFilter = (0, cloneDeep_1.default)(selectedAuditKeyByLevel);
                    const newFilterValue = (newValue || []).map((v) => v.value);
                    existingFilter[level] = newFilterValue;
                    const newFilter = [];
                    for (const level of auditLevels) {
                        newFilter.push(...existingFilter[level]);
                    }
                    setFilter(newFilter);
                }, name: `surveyValidation-filter-audit-level-${level}`, options: groupedChoices, className: "basic-multi-select", classNamePrefix: t('admin:Select') })));
    }
    return react_1.default.createElement(react_1.default.Fragment, null, auditFilterSelects);
};
exports.ValidationAuditFilter = ValidationAuditFilter;
exports.default = (0, react_i18next_1.withTranslation)(['survey', 'admin', 'main'])(exports.ValidationAuditFilter);
//# sourceMappingURL=ValidationAuditFilter.js.map